// TableHead.tsx
import { Box, Checkbox, TableCell, TableHead, TableRow } from '@mui/material'
import * as React from 'react'
import CommonSortComponent from '../CommonSortComponent'
import { HeadCell } from '../types'

interface EnhancedTableHeadProps {
  numSelected?: number
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void
  rowCount: number
  isAllSelected?: boolean
  isCheckbox?: boolean | undefined
  isAction?: boolean | undefined
  headCells: HeadCell[]
  onClick?: (key: string, direction: string) => void
  filterType?: {
    key: string
    direction: string
  }
}

export default function TableHeadComponent({
  numSelected,
  onSelectAllClick,
  rowCount,
  headCells,
  isAllSelected,
  isCheckbox,
  isAction,
  onClick,
  filterType
}: EnhancedTableHeadProps) {
  const handleSortStatus = (id: string) => {
    if (filterType?.direction === 'asc') {
      onClick?.(id, 'desc')
    } else if (filterType?.direction === 'desc') {
      onClick?.('', '')
    } else {
      onClick?.(id, 'asc')
    }
  }

  return (
    <TableHead className='bg-gray-100 text-gray-700'>
      <TableRow>
        {!isCheckbox && (
          <TableCell
            padding='checkbox'
            sx={{
              backgroundColor: '#f3f4f6',
              color: '#374151'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
              <Checkbox
                color='primary'
                // indeterminate={numSelected > 0 && !isAllSelected}
                checked={isAllSelected}
                onChange={onSelectAllClick}
              />
              {(numSelected ?? 0) > 0 && <>({numSelected})</>}
            </Box>
          </TableCell>
        )}
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            align={'left'}
            padding={'normal'}
            sx={{
              backgroundColor: '#f3f4f6',
              color: '#374151',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
              cursor: headCell.id && headCell.id === 'last_connected_at' ? 'pointer' : 'default'
            }}
            onClick={() => headCell.id && headCell.id === 'last_connected_at' && handleSortStatus(headCell.id)}
          >
            <CommonSortComponent
              title={headCell.label}
              sortConfig={filterType}
              configKey={headCell.id === 'last_connected_at' ? 'last_connected_at' : ''}
            />
          </TableCell>
        ))}
        {!isAction && (
          <TableCell
            sx={{
              backgroundColor: '#f3f4f6',
              color: '#374151',
              whiteSpace: 'nowrap'
            }}
          >
            ACTIONS
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  )
}
